import React from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const InfoFilledIcon = ({ size = defaultSize }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM13 8C13 7.44772 12.5523 7 12 7C11.4477 7 11 7.44772 11 8V8.02261C11 8.5749 11.4477 9.02261 12 9.02261C12.5523 9.02261 13 8.5749 13 8.02261V8ZM11.5 10.5C10.9477 10.5 10.5 10.9477 10.5 11.5C10.5 11.8701 10.7011 12.1933 11 12.3662V15C10.4477 15 10 15.4477 10 16C10 16.5523 10.4477 17 11 17H13C13.5523 17 14 16.5523 14 16C14 15.4477 13.5523 15 13 15V12C13 11.1716 12.3284 10.5 11.5 10.5Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

InfoFilledIcon.propTypes = {
  ...sizePropsTypes,
};

export default InfoFilledIcon;
